import type React from 'react';

/**
 * The debit → credit arrow between the two boxes of a pair.
 *
 * Not decoration. A journal pair is a *movement* — this account is debited so
 * that one can be credited — and two boxes sitting side by side say only that
 * there are two of them. The arrow is what makes the card readable at a glance
 * as one sentence rather than as two fields, which is the whole reason the pair
 * is the unit of this editor.
 *
 * Drawn inline rather than pulled from the icon set so the three things that
 * make it read correctly are fixed here: a **long shaft** (a stubby chevron
 * reads as "expand", not "flows to"), a stroke weight matched to the box
 * borders, and `currentColor`, so it inherits the muted tone of the card and
 * never competes with the account codes on either side of it.
 *
 * It rotates a quarter-turn when the pair stacks on a narrow screen, because a
 * rightward arrow between two vertically stacked boxes points at nothing.
 *
 * `aria-hidden`: the direction is already carried in text by the DEBIT and
 * CREDIT labels inside the boxes, and a screen reader announcing "right arrow"
 * between them adds noise rather than meaning.
 */
export const PairArrow: React.FC = () => (
    <span
        aria-hidden
        className="flex justify-center self-center py-1 text-muted sm:self-start sm:pt-9"
    >
        <svg
            className="size-[18px] rotate-90 sm:rotate-0"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.7}
            viewBox="0 0 24 24"
        >
            <path d="M5 12h14" />
            <path d="M13 6l6 6-6 6" />
        </svg>
    </span>
);
